export const actions = {
  UPDATE: 'coursesLitmos/update',
  CLEAR: 'coursesLitmos/clear',
};

interface Course {
  font?: string;
  color?: string;
  image?: string;
  whiteLabel?: string;
  bestEditInstructions?: string;
  bestProvisionInstructions?: string;
  allPartsInstructions?: string;
  allApplyInstructions?: string;
  allApplySingleInstructions?: string;
  bestSpotInstructions?: string;
}

type CourseOrNone = Course | void;

interface CourseAction {
  type: typeof actions.UPDATE | typeof actions.CLEAR;
  payload: CourseOrNone;
}

type CourseActionTypes = CourseAction;

export const update = (payload: Course) => {
  return {
    type: actions.UPDATE,
    payload,
  };
};

export const clear = () => {
  return {
    type: actions.CLEAR,
  };
};

export const initialState = {
  coursesList: [],
  modalIsOpen: false,
  font: 'Arial',
  color: '#000000',
  currentCourse: null,
  image: null,
  whiteLabel: null,
  bestEditInstructions: '',
  bestProvisionInstructions: '',
  allPartsInstructions: '',
  allApplyInstructions: '',
  allApplySingleInstructions: '',
  bestSpotInstructions: '',
};

export const coursesLitmosReducer = (
  state = initialState,
  action: CourseActionTypes
) => {
  switch (action.type) {
    case actions.UPDATE:
      return {
        ...state,
        ...action.payload,
      };
    case actions.CLEAR:
      return initialState;
    default:
      return state;
  }
};
